<template>
  <b-dropdown
    position="is-bottom-right"
    :mobile-modal="false"
  >
    <template #trigger="{ active }">
      <img
        class="logo"
        src="/images/forefront-icon.png"
        alt="Forefront"
      >
    </template>

    <a
      class="navbar-item"
      @click="logout"
    >Logout</a>
  </b-dropdown>
</template>

<script>
import auth from "../../../api/auth";
import router from "../../../router";

export default {
  name: "MobileLogoMenu",
  methods: {
    logout() {
      auth.logout().then(() => {
        router.push({ name: 'login' });
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.logo {
  height: $headerHeight - 16px;
}
</style>
